import { ApiQuery } from '@kinet-open-network/client/core/api-client';
import {
  patchState,
  signalStoreFeature,
  withMethods,
  withState,
} from '@ngrx/signals';

export interface WithQueryConfig {
  initial?: ApiQuery | null;
  resetToInitial?: boolean;
}

export function withQuery(config?: WithQueryConfig) {
  return signalStoreFeature(
    withState<{
      query: ApiQuery | null;
    }>({
      query: config?.initial ?? null,
    }),
    withMethods((store) => ({
      patchQuery: (partialQuery: Partial<ApiQuery> | null) => {
        if (partialQuery === null) {
          return patchState(store, {
            query: config?.resetToInitial ? config?.initial ?? null : null,
          });
        }

        /**
         * If the partial query is the same as the current query, do nothing!
         *
         * We need to do this because when the query is updated, and components
         * attached to the query triggers a change, it will call the patchQuery
         * method with the same query, causing an infinite loop
         */
        const storedQuery = store.query();
        const oldPartialQuery = Object.keys(partialQuery).reduce((acc, key) => {
          (acc[key as keyof ApiQuery] as unknown) =
            storedQuery?.[key as keyof ApiQuery];
          return acc;
        }, {} as Partial<ApiQuery>);

        if (JSON.stringify(oldPartialQuery) === JSON.stringify(partialQuery)) {
          return;
        }

        patchState(store, { query: { ...store.query(), ...partialQuery } });
      },
    })),
  );
}
